import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 ${
          size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 韩漫免费阅读`}
          title={`${comic.title} - 无删减漫画免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
        {comic.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md">
            热门
          </span>
        )}
        {comic.isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md">
            新作
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 right-2 px-2 py-0.5 text-xs font-medium bg-secondary-500 text-background-50 rounded-md">
            完结
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-sm font-semibold text-white truncate leading-tight">
            {comic.title}
          </h3>
          <p className="text-xs text-white/70 mt-1 truncate">
            {comic.author}
          </p>
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between px-1">
        <span className="text-xs text-foreground-500">{comic.category}</span>
        <span className="flex items-center gap-1 text-xs text-accent-500">
          <i className="ri-star-fill text-[10px]"></i>
          {comic.rating}
        </span>
      </div>
    </Link>
  );
}